import React, { useContext } from 'react';
import { ExerciseTranslationsContext } from '../../contexts/ExerciseTranslationsContext.js';
import { ExerciseDialogsContext } from '../../../../context/ExerciseDialogsContext.js';
import { ModalDialog, Dialog } from '../../../dialog/index.js';
import { Button } from '../../../button/index.js';

const ExercisePauseDialog = ({ onClose, onPause }) => {
    const translations = useContext(ExerciseTranslationsContext);
    const dialogContext = useContext(ExerciseDialogsContext);
    return (React.createElement(ModalDialog, { id: 'exercise-pause-dialog', onClose: onClose, closeTitle: translations.closeDialog, closeViaEscape: true, className: 'exercise-dialogs' },
        React.createElement(Dialog.Header, { title: translations.exercisePauseDialog.title, startAdornment: dialogContext.header.iconClassName ? (React.createElement("i", { className: dialogContext.header.iconClassName, role: 'img' })) : (undefined) }),
        React.createElement(Dialog.Body, null,
            React.createElement("p", null, translations.exercisePauseDialog.message.p1),
            React.createElement("p", null, translations.exercisePauseDialog.message.p2)),
        React.createElement(Dialog.Footer, { "data-testid": 'exercise-pause-footer' },
            React.createElement(Button, { variant: 'secondary', onClick: onClose }, translations.exercisePauseDialog.buttons.continue),
            React.createElement(Button, { variant: 'primary', onClick: onPause }, translations.exercisePauseDialog.buttons.pause))));
};

export { ExercisePauseDialog };
